import styled from 'styled-components';

export const Container = styled.div`
  background: ${props => props.theme.colors.white_variant};
  border-radius: 0.8rem;
  padding: 0.8rem;

  .mobile & {
    margin: 0 15px;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
  height: 100%;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  margin-bottom: 0.6rem;
  width: 100%;
  span {
    font-size: 1.2rem;
  }

  .mobile & {
    padding: 0px 15px;
    > span {
      width: calc(100% - 30px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 15px 0px 15px;
      font-size: 12px;
    }
  }
`;

export const SearchInput = styled.div`
  border: 0.1rem solid ${props => props.theme.colors.grey};
  border-radius: 0.8rem;
  width: 50%;
  height: 1.6rem;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);

  display: flex;
  align-items: center;
  padding: 0 0.1rem;

  #search {
    padding: 0.4rem;
  }

  input {
    border: none;
    width: 100%;
    background: transparent;
    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${props => props.theme.colors.dark_grey};
    }
  }
`;

export const ListBody = styled.div`
  width: 100%;
  height: auto;
  max-height: 40rem;
  overflow: auto;
  overflow-x: hidden;
`;

export const SelectBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ccc;

  & > div:first-child {
    width: 15px;
  }
`;

export const Letter = styled.div`
  color: #929292;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 3px;
  padding: 5px 0;
  div {
    input {
      color: ${props => props.theme.colors.primary};
    }
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0 1.5rem 0;
`;

export const Redirect = styled.a`
  display: inline-block;
  .btn {
    border: none;
    border-radius: 100px;
    padding: 6px 25px;
    transition: all .2s;
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 5px;
    position: relative;
  }

  .btn:hover {
    transform: translateY(0px);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }

  .btn:active {
    transform: translateY(-2px);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  }

  .btn-white {
    background-color: ${props => props.theme.colors.primary};
    color: white;
  }

  .btn::after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 100%;
    border-radius: 100px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all .4s;
  }

  .btn-white::after {
    background-color: ${props => props.theme.colors.primary};
    opacity: .2;
  }

  .btn:hover::after {
    transform: scaleX(1.2) scaleY(1.2);
    opacity: 0;
  }

  .btn-animate {
    animation: moveInBottom 1s ease-out;
    animation-fill-mode: backwards;

    & > svg {
        color: white !important;
    }
  }

  @keyframes moveInBottom {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }

    100% {
        opacity: 1;
        transform: translateY(0px);
    }
  }
`;